import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";
import { Input } from "../../../profile/profile.styled";

const fadeIn = keyframes`
  from { opacity: 0 }
  to { opacity: 1 }
`;

const slideUp = keyframes`
  from { transform: translateY(12px); opacity: 0 }
  to { transform: translateY(0); opacity: 1 }
`;

export const Overlay = styled.div`
    position: fixed;
    inset: 0;
    @media (min-width: 768px) { left: var(--sidebar-width, 0px); }
    background: rgba(5, 7, 12, 0.5);
    z-index: 1001;
    animation: ${fadeIn} 160ms ease-out both;
`;

export const ModalShell = styled.div`
    position: fixed;
    inset: 0;
    @media (min-width: 768px) { left: var(--sidebar-width, 0px); }
    z-index: 1002;
    display: grid;
    place-items: center;
    pointer-events: none;
`;

export const Dialog = styled.div`
    width: calc(100% - 32px);
    pointer-events: auto;
    animation: ${slideUp} 200ms ease-out both;
`;

export const Field = styled.div`
    display: grid;
    gap: 4px;
`;

export const Label = styled.label`
    font-size: 12px;
    color: #aab3c5;
`;

export const ActionBar = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
    width: 100%;
`;

export const CancelBtn = styled.button`
    background: none;
    border: 0;
    padding: 0;
    margin: 0;
    cursor: pointer;
    font-weight: 500;
    font-size: 14px;
    color: #5e84ed;
    text-decoration: none;
`;

export const InputWithToggle = styled(Input)<{ $hasToggle?: boolean }>`
    padding-right: ${({ $hasToggle }) => ($hasToggle ? "44px" : "14px")};
`;

export const InputWrap = styled.div`
    position: relative;
    width: 100%;
`;

export const EyeToggle = styled.button`
    all: unset;
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    line-height: 0;
    color: #aab3c5;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 4px;

    &:hover {
        color: #c7d0e6;
    }

    &:focus-visible {
        outline: 2px solid #5e84ed;
        outline-offset: 2px;
        border-radius: 6px;
    }
`;
